import { render, staticRenderFns } from "./PlatformHeaderScreen.vue?vue&type=template&id=3780563a&scoped=true"
import script from "./PlatformHeaderScreen.vue?vue&type=script&lang=js"
export * from "./PlatformHeaderScreen.vue?vue&type=script&lang=js"
import style0 from "./PlatformHeaderScreen.vue?vue&type=style&index=0&id=3780563a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780563a",
  null
  
)

/* custom blocks */
import block0 from "./PlatformHeaderScreen.vue?vue&type=custom&index=0&blockType=platform-header&title=%E5%95%86%E5%8A%A1%E6%94%BF%E7%AD%96%E8%80%83%E6%A0%B8&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports